// services/invoiceReminderService.js

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class InvoiceReminderService {
  
  // Save invoice reminder settings
  async saveReminderSettings(settings) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/invoice-reminders`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Add authentication headers if needed
          // 'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(settings)
      });

      if (!response.ok) {
        throw new Error(`Failed to save settings: ${response.status}`);
      }

      const data = await response.json();
      return {
        success: true,
        data: data
      };
    } catch (error) {
      console.error('Error saving reminder settings:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Get current invoice reminder settings
  async getReminderSettings() {
    try {
      const response = await fetch(`${API_BASE_URL}/invoice-reminders`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // Add authentication headers if needed
          // 'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch settings: ${response.status}`);
      }

      const data = await response.json();
      return {
        success: true,
        data: data
      };
    } catch (error) {
      console.error('Error fetching reminder settings:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Update specific reminder settings
  async updateReminderSettings(settingsId, updates) {
    try {
      const response = await fetch(`${API_BASE_URL}/invoice-reminders/${settingsId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          // Add authentication headers if needed
          // 'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(updates)
      });

      if (!response.ok) {
        throw new Error(`Failed to update settings: ${response.status}`);
      }

      const data = await response.json();
      return {
        success: true,
        data: data
      };
    } catch (error) {
      console.error('Error updating reminder settings:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Delete reminder settings
  async deleteReminderSettings(settingsId) {
    try {
      const response = await fetch(`${API_BASE_URL}/invoice-reminders/${settingsId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          // Add authentication headers if needed
          // 'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to delete settings: ${response.status}`);
      }

      return {
        success: true,
        message: 'Settings deleted successfully'
      };
    } catch (error) {
      console.error('Error deleting reminder settings:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Test API connection
  async testConnection() {
    try {
      const response = await fetch(`${API_BASE_URL}/health`, {
        method: 'GET'
      });
      
      return response.ok;
    } catch (error) {
      console.error('API connection test failed:', error);
      return false;
    }
  }
}

// Export singleton instance
const invoiceReminderService = new InvoiceReminderService();
export default invoiceReminderService;